import TemplateView from '../../../../TemplateView'
import {getAbbrDayNameKey} from '../../utils'

export default class MonthHeaderDay extends TemplateView {
    constructor({
        dayNum,
    } = {}) {
        super()

        this.params = {
            dayNum,
        }
    }

    templateHtml() {
        return "<div class='monthHeaderDay'><%=dayShortName%></div>"
    }

    messageKeys() {
        return {
            dayShortName: getAbbrDayNameKey(this.params.dayNum),
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/month/MonthHeaderDay.js